export const COMPANY_SITE_URL = 'https://uniforce.co.jp/'
export const PRIVACY_POLICY_URL = 'https://uniforce.co.jp/privacy/'
